"use client";
import React from "react";
import { LinkListProps } from "../types";
import ContentColumnLinks from "./ContentColumnLinks";
import useTranslations from "@/i18n/useTranslations";

export default function ContentColumns({ title }: LinkListProps) {
  const t = useTranslations("LinkList");
  // Used in Course Landing Shop Page "explore"
  const contentColumnsData = {
    title: title,
    columns: [
      {
        subtitle: t("earnADegree"),
        description: t("earnADegreeDescription"),
        links: [
          {
            className: "text-link underline",
            href: "https://www.edx.org/masters",
            text: t("onlineMastersDegrees"),
          },
          {
            className: "text-link underline",
            href: "https://www.edx.org/bachelors",
            text: t("onlineBachelorsDegrees"),
          },
          {
            className: "text-link underline",
            href: "https://www.edx.org/doctorate",
            text: t("onlineDoctorateDegrees"),
          },
          {
            className: "text-link underline",
            href: "https://www.edx.org/masters/micromasters",
            text: t("microMastersPrograms"),
          },
          {
            className: "text-link underline",
            href: "https://www.edx.org/bachelors/microbachelors",
            text: t("microBachelorsPrograms"),
          },
        ],
      },
      {
        subtitle: t("gainACredential"),
        description: t("gainACredentialDescription"),
        links: [
          {
            className: "text-link underline",
            href: "https://www.edx.org/",
            text: t("onlineCourses"),
          },
          {
            className: "text-link underline",
            href: "https://www.edx.org/certificates",
            text: t("onlineCertificates"),
          },
        ],
      },
      {
        subtitle: t("elevateYourCareer"),
        description: t("elevateYourCareerDescription"),
        links: [
          {
            className: "text-link underline",
            href: "https://www.edx.org/executive-education",
            text: t("onlineExecutiveEducationPrograms"),
          },
        ],
      },
    ],
  };

  return (
    <>
      <h3>{contentColumnsData.title}</h3>
      <div className="grid grid-cols-1 lg:grid-cols-3">
        {contentColumnsData.columns.map((column, index) => (
          <ContentColumnLinks key={index} {...column} />
        ))}
      </div>
    </>
  );
}
